import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getTicketsByEvent = async (params: {
  event_id: number;
  category_id?: number;
  keyword?: string;
  page?: number;
  pageSize?: number;
}) => {
  const url = endpoints.SEATING_TICKETS;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const getCategoriesByEvent = async (event_id: number) => {
  const url = endpoints.SEATING_CATEGORIES;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: { event_id },
  });

  return response;
};

const downloadTemplate = async (event_id: number, category_id?: number, eventName?: string) => {
  const url = endpoints.SEATING_DOWNLOAD_TEMPLATE;

  const params: any = { event_id };
  if (category_id) {
    params.category_id = category_id;
  }

  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
      params,
    })
    .then((res) => {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const categoryText = category_id ? `-category-${category_id}` : "";
      fileDownload(blob, `seating-template-event-${event_id}${categoryText}-${eventName || 'tickets'}.xlsx`);
    });
};

const uploadSeatingFile = async (
  file: File,
  event_id: number,
  category_id?: number
) => {
  const url = endpoints.SEATING_UPLOAD;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("event_id", event_id.toString());
  if (category_id) {
    formData.append("category_id", category_id.toString());
  }

  const { data: response } = await axios.post(url, formData, {
    headers: {
      Authorization: accessToken,
      "Content-Type": "multipart/form-data",
    },
  });

  return response;
};

const getJobStatus = async (event_id: number, category_id?: number) => {
  const url = endpoints.SEATING_JOB_STATUS;

  const params: any = { event_id };
  if (category_id) {
    params.category_id = category_id;
  }

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const generateTicketLink = async (ticket_id: number) => {
  const url = endpoints.SEATING_GENERATE_LINK;

  const { data: response } = await axios.post(
    url,
    { ticket_id },
    {
      headers: {
        Authorization: accessToken,
      },
    }
  );

  return response;
};

const getSeats = async (event_id: number, category_id?: number) => {
  const url = endpoints.SEATING_GET_SEATS;

  const params: any = { event_id };
  if (category_id) {
    params.category_id = category_id;
  }

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const service = {
  getTicketsByEvent,
  getCategoriesByEvent,
  downloadTemplate,
  uploadSeatingFile,
  getJobStatus,
  generateTicketLink,
  getSeats,
};

export default service;
